// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__ZjPoj","paramInput":"JobSimulator_paramInput__3nXyV","input":"JobSimulator_input__1hfBp"};